<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <md-card>
      <md-card-content>
        <md-layout md-gutter>
          <md-layout md-flex="10">
            <md-button
              class="md-raised md-primary md-button-color md-theme-default back heght-1px"
              @click="previousPoView"
              >&laquo; Back</md-button
            >
          </md-layout>
          <md-layout md-flex="30"></md-layout>
          <md-layout md-flex="40" class="mobile-width">
            <h3 v-if="stockInDetails.poOrderId == ''"><b>New Purchase Order</b></h3>
            <h3 v-else><b>Update Purchase Order</b></h3>
          </md-layout>
        </md-layout>

        <hr class="hr-s" />
        <b-row>
          <b-col md="4">
            <label>Added By</label>
            <model-list-select
              :list="employeeMasterList"
              isDisabled
              v-model="stockInDetails.addedByPerson"
              option-value="employeeName"
              option-text="employeeName"
            ></model-list-select>
            <span class="error" v-if="!stockInDetails.addedByPerson">{{
              addedByPersonError
            }}</span>
          </b-col>
          <b-col md="2">
            <label class="w-100">PO Date</label>
            <date-picker
              :format="selectDateFormat"
              lang="en"
              v-model="stockInDetails.poDate"
              :disabled="permissionStatus || stockInDetails.poOrderId != ''"
              id="Date"
              @input="enablePoExpiryDate()"
            ></date-picker>
            <span class="error" v-if="!stockInDetails.poDate">{{ poDateError }}</span>
          </b-col>

          <b-col md="2">
            <label class="w-100">PO Expiry Date</label>
            <date-picker
              :format="selectDateFormat"
              lang="en"
              v-model="stockInDetails.poExpiryDate"
              :disabled="
                (permissionStatus && stockInDetails.isPODateSelected == true) ||
                stockInDetails.poOrderId != ''
              "
              id="Date"
              :not-before="minExpiryDate"
            ></date-picker>
          </b-col>
          <b-col md="4">
            <label for="maintenanceType">Maintenance Type</label>
            <span class="error">*</span>
            <model-list-select
              :isDisabled="stockInDetails.poOrderId != ''"
              :list="maintenanceTypeList"
              v-model="stockInDetails.maintenanceType"
              option-value="maintenanceTypeVal"
              option-text="maintenanceTypeText"
              placeholder="Maintenance Type"
            ></model-list-select>
            <span class="error" v-if="!stockInDetails.maintenanceType">{{
              maintenanceTypeError
            }}</span>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="4">
            <label for="location">Location</label> <span class="error">*</span>
            <model-list-select
              :isDisabled="stockInDetails.poOrderId != ''"
              :list="locationMasterList"
              v-model="stockInDetails.location"
              option-value="pickupId"
              option-text="pickupLocation"
              placeholder="Select Location"
            ></model-list-select>
            <span class="error" v-if="!stockInDetails.location">{{ locationError }}</span>
          </b-col>

          <b-col md="4">
            <b-row>
              <b-col md="9">
                <label for="vendorName">Vendor Name</label> <span class="error">*</span>
                <model-list-select
                :isDisabled="stockInDetails.poOrderId != ''"
                  :list="$store.getters['commonDropdownMaster/getAllTallyVendorList']"
                  id="vendor_id"
                  v-model="stockInDetails.vendorName"
                  option-value="vendor_id"
                  option-text="vendor_LglNm"
                  placeholder="Select Vendor Name "
                  @input="GstDataGet(stockInDetails.vendorName, '')"
                ></model-list-select>
                <span class="error" v-if="!stockInDetails.vendorName">{{
                  vendorNamError
                }}</span>
              </b-col>

              <b-col md="3" v-if="stockInDetails.poOrderId == ''">
                <b-button
                  variant="info"
                  @click="openVendorNameModal()"
                  id="addButtonLoader"
                  size="sm"
                  style="margin-top: 40px"
                  >Add</b-button
                >
              </b-col>
            </b-row>
          </b-col>
          

          <b-col md="4" v-if="stockInDetails.vendorName != ''">
            <label>Vendor GST</label>
            <model-list-select
            :isDisabled="stockInDetails.poOrderId != ''"
              class="ml-1"
              :list="
                $store.getters['commonDropdownMaster/getAllTallyVendorGstList'].length > 0
                  ? $store.getters['commonDropdownMaster/getAllTallyVendorGstList']
                  : notApplicableArr
              "
              id="vendor_add_id"
              v-model="stockInDetails.fk_vendor_add_id"
              option-value="vendor_add_id"
              option-text="Gstnumber"
              placeholder="Select Vendor GST"
              @input="
                GstDataGet(stockInDetails.vendorName, stockInDetails.fk_vendor_add_id);checkVendorPridelGSTCode();
              "
            ></model-list-select>

            <!-- <h5 v-if="stockInDetails.vendorName != '' && $store.getters['commonDropdownMaster/getAllTallyVendorGstList'].length == 0" class="error mt-2"><b>GST Not Applicable of the Selected Vendor</b></h5> -->
            <!-- <span class="error" v-if="!stockInDetails.fk_vendor_add_id">{{vendorGSTError}}</span> -->
          </b-col>
          <b-col md="4">
            <label>Branch <span class="error">*</span></label>
               <!-- :isDisabled="stockInDetails.poOrderId && stockInDetails.fk_branch_id" -->
            <model-list-select
              id="fk_branch_id"
              :list="$store.getters['common/getAllBranchList']"
              v-model="stockInDetails.fk_branch_id"
              option-value="pickupId"
              option-text="pickupLocation"
              placeholder="Select Branch"
              @input="onBranchSelected"
            />
            <span class="error" v-if="!stockInDetails.fk_branch_id">{{
              branchError
            }}</span>
          </b-col>
          <b-col md="4">
            <label>Branch GST <span class="error">*</span></label>
            <model-list-select
              id="fk_office_id"
              :list="BranchOfficeList"
              v-model="stockInDetails.fk_office_id"
              option-value="office_id"
              option-text="long_gst_no"
              placeholder="Select GST"
              @input="getGSTNO(stockInDetails.fk_office_id);checkVendorPridelGSTCode();"
            />
            <span class="error" v-if="!stockInDetails.branchGSTN">{{
              branchGstError
            }}</span>
          </b-col>
        </b-row>

        <b-row>
          <b-col md="9">
            <label>Specific Details on PO,if any..</label>
            <b-form-textarea
              :formatter="capitalizeAll"
              id="specificPoDetail"
              name="specificPoDetail"
              v-model="stockInDetails.specificPoDetail"
            ></b-form-textarea>
          </b-col>

          <b-col md="2" class="mt-5">
            <b-button
              v-if="itemArrayShow.length <= 0"
              :disabled="!stockInDetails.vendorName"
              variant="warning"
              @click="showAddItemPanel()"
              id="addButtonLoader"
            >
              Add items in PO
            </b-button>
          </b-col>
        </b-row>

        <div v-if="addItemPanel || itemArrayShow.length > 0">
          <hr class="hr-s mt-4" />
          <b-row>
            <b-col md="12" class="mt-2 mb-2">
              <h5><b> Add Items in PO </b></h5>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="3" v-if="itemModal.poItemId == ''">
              <b-col md="8">
                <label for="itemMasterAll">Item Name - Part Number</label>
                <model-list-select
                  id="itemMasterAll"
                  :list="itemMasterList"
                  v-model="itemMasterAll"
                  option-value="itemId"
                  option-text="displayList"
                  placeholder="Select Item Name"
                  @input="getItemDetails(itemMasterAll)"
                ></model-list-select>
                <span class="error" v-if="!itemMasterAll.itemId">{{
                  itemNameError
                }}</span>
              </b-col>

              <b-col md="1">
                <b-button
                  variant="primary"
                  @click="openItemModal()"
                  id="addButtonLoader"
                  size="sm"
                  style="margin-top: 40px"
                >
                  Add New Item
                </b-button>
              </b-col>
            </b-col>

            <b-col md="3" v-else>
              <label for="itemMasterAll">Item Name - Part Number</label>
              <b-form-input
                :formatter="capitalizeAll"
                id="specificPoDetail"
                name="specificPoDetail"
                v-model="itemModal.dummyItemName"
                disabled
              ></b-form-input>
            </b-col>
            <b-col md="2">
              <label>Unit <span class="error">*</span></label>
              <model-list-select
                :list="UnitList"
                v-model="itemModal.unit"
                option-value="unitVal"
                option-text="unitText"
                placeholder="Select Unit"
              ></model-list-select>
            </b-col>

            <b-col md="1">
              <label>Quantity</label><span class="error">*</span>
              <b-form-input
                :formatter="capitalizeAll"
                id="itemQuantity"
                name="itemQuantity"
                v-model="itemModal.itemQuantity"
                type="number"
                min="1"
                @input="emptyRate()"
              ></b-form-input>
              <span class="error" v-if="!itemModal.itemQuantity">{{
                itemQuantityError
              }}</span>
            </b-col>

            <b-col md="1">
              <label>Rate Per Unit</label><span class="error">*</span>
              <b-form-input
                :formatter="capitalizeAll"
                id="po_ratePerUnit"
                name="po_ratePerUnit"
                v-model="itemModal.po_ratePerUnit"
                @input="calTotalRate(itemModal.po_ratePerUnit)"
                @change="calTotalRateAndRoundRate(itemModal.po_ratePerUnit)"
                type="number"
              ></b-form-input>
              <span class="error" v-if="!itemModal.po_ratePerUnit">{{
                poRatePerUnitError
              }}</span>
            </b-col>

            <b-col md="2">
              <label>Gross Amount</label>
              <b-form-input
                :formatter="capitalizeAll"
                disabled
                id="totalAmount"
                name="totalAmount"
                v-model="itemModal.totalAmount"
                type="number"
                min="0"
              ></b-form-input>
            </b-col>

            <b-col md="1" v-if="this.vendorStateCode != this.pridelGSTCode">
              <label>IGST (%)</label><span class="error">*</span>
              <model-list-select
                :list="igstList"
                id="igst"
                v-model="itemModal.igst"
                option-value="igstVal"
                option-text="igstText"
                placeholder="IGST %"
                @input="calFinalAmount()"
                @change="calFinalAmount()"
              ></model-list-select>
              <span class="error" v-if="!itemModal.igst">{{ igstError }}</span>

              <!-- Hidden Field just for submition of value and calculation purpose -->
              <label style="display: none">IGST Amount</label>
              <b-form-input
                :formatter="capitalizeAll"
                disabled
                id="igst_amount"
                name="igst_amount"
                v-model="itemModal.igst_amount"
                type="number"
                style="display: none"
              ></b-form-input>
            </b-col>

            <b-col md="1" v-if="this.vendorStateCode == this.pridelGSTCode">
              <label>CGST (%)</label><span class="error">*</span>
              <model-list-select
                :list="gstList"
                id="cgst"
                v-model="itemModal.cgst"
                option-value="gstVal"
                option-text="gstText"
                placeholder="CGST %"
                @input="calFinalAmount()"
                @change="calFinalAmount()"
              ></model-list-select>
              <span class="error" v-if="!itemModal.cgst">{{ cgstError }}</span>

              <!-- Hidden Field just for submition of value and calculation purpose -->
              <label style="display: none">CGST Amount</label>
              <b-form-input
                :formatter="capitalizeAll"
                disabled
                id="cgst_amount"
                name="cgst_amount"
                v-model="itemModal.cgst_amount"
                type="number"
                style="display: none"
              ></b-form-input>
            </b-col>

            <b-col md="1" v-if="this.vendorStateCode == this.pridelGSTCode">
              <label>SGST (%)</label>
              <model-list-select
                isDisabled
                :list="gstList"
                id="sgst"
                v-model="itemModal.sgst"
                option-value="gstVal"
                option-text="gstText"
                placeholder="SGST %"
              ></model-list-select>

              <!-- Hidden Field just for submition of value and calculation purpose -->
              <label style="display: none">SGST Amount</label>
              <b-form-input
                :formatter="capitalizeAll"
                disabled
                id="sgst_amount"
                name="sgst_amount"
                v-model="itemModal.sgst_amount"
                type="number"
                style="display: none"
              ></b-form-input>
            </b-col>

            <b-col md="2">
              <label>Total Amount</label>
              <b-form-input
                :formatter="capitalizeAll"
                disabled
                id="final_amount"
                name="final_amount"
                v-model="itemModal.final_amount"
                type="number"
                min="0"
              ></b-form-input>
            </b-col>

            <b-col md="1">
              <label>Currency Type</label>
              <model-list-select
                isDisabled
                :list="$store.getters['common/getAllCurrencyList']"
                v-model="itemModal.fk_currency_id"
                option-value="currency_id"
                option-text="currencyCode"
                placeholder="INR"
              ></model-list-select>
            </b-col>

            <b-col md="8">
              <label>Remarks</label>
              <b-form-textarea
                :formatter="capitalizeAll"
                id="remarks"
                name="remarks"
                v-model="itemModal.remarks"
              ></b-form-textarea>
            </b-col>

            <b-col md="2">
              <b-button class="mt-5 py-2" variant="primary" @click="addItem">
                {{ updateItemFlag ? "Update Item" : "Add Item" }}
              </b-button>
            </b-col>
          </b-row>

          <div style="background: beige">
            <hr class="hr-s" v-if="itemArrayShow.length > 0" />
            <div class="box" v-if="itemArrayShow.length > 0">
              <div class="box-header">
                <h3 class="box-title">Itemized Stock Details</h3>
              </div>

              <div class="box-body table-striped table-responsive">
                <table id="poTable" class="table table-bordered">
                  <thead>
                    <tr>
                      <th>SN.</th>
                      <th>Item Name</th>
                      <th>Quantity</th>
                      <th>Rate per Unit</th>
                      <th>Gross Amount</th>

                      <th v-if="vendorStateCode != pridelGSTCode">IGST (%)</th>
                      <th v-if="vendorStateCode != pridelGSTCode">IGST Amount</th>

                      <th v-if="vendorStateCode == pridelGSTCode">CGST (%)</th>
                      <th v-if="vendorStateCode == pridelGSTCode">CGST Amount</th>

                      <th v-if="vendorStateCode == pridelGSTCode">SGST (%)</th>
                      <th v-if="vendorStateCode == pridelGSTCode">SGST Amount</th>

                      <th>Total Amount</th>
                      <th>Remarks</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in itemArrayShow" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.itemName }}</td>
                      <td>{{ item.itemQuantity }}</td>
                      <td>{{ item.po_ratePerUnit }}</td>
                      <td>{{ item.currency }} {{ item.totalAmount }}</td>

                      <td v-if="vendorStateCode != pridelGSTCode">
                        {{ item.igst }} <small v-if="item.igst">%</small>
                      </td>
                      <td v-if="vendorStateCode != pridelGSTCode">
                        {{ item.currency }} {{ item.igst_amount }}
                      </td>

                      <td v-if="vendorStateCode == pridelGSTCode">
                        {{ item.cgst }} <small v-if="item.cgst">%</small>
                      </td>
                      <td v-if="vendorStateCode == pridelGSTCode">
                        {{ item.currency }} {{ item.cgst_amount }}
                      </td>

                      <td v-if="vendorStateCode == pridelGSTCode">
                        {{ item.sgst }} <small v-if="item.sgst">%</small>
                      </td>
                      <td v-if="vendorStateCode == pridelGSTCode">
                        {{ item.currency }} {{ item.sgst_amount }}
                      </td>

                      <td>{{ item.currency }} {{ item.final_amount }}</td>
                      <td>{{ item.remarks }}</td>
                      <td>
                        <md-button
                          class="md-icon-button md-raised md-dense"
                          @click="viewModalPage(item.poItemId)"
                        >
                          <md-icon style="color: rgb(55, 100, 151)">edit</md-icon>
                        </md-button>

                        <md-button
                          class="md-icon-button md-raised md-dense"
                          @click="deleteItemConfirmation(item)"
                        >
                          <md-icon style="color: rgb(166, 34, 30)">delete</md-icon>
                        </md-button>
                      </td>
                    </tr>

                    <tr>
                      <td
                        v-if="vendorStateCode == pridelGSTCode"
                        colspan="10"
                        class="grandTotalSection"
                      >
                        <b>Grand Total Amount:</b>
                      </td>

                      <td v-else colspan="8" class="grandTotalSection">
                        <b>Grand Total Amount:</b>
                      </td>

                      <td colspan="4">
                        <span class="success"
                          ><b> INR {{ grandTotalAmount.toFixed(2) }} /- </b></span
                        >
                        <br />
                        <span class="success"
                          ><b> {{ grandTotalInWords }} Only </b></span
                        >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <hr class="hr-s" />
          </div>
        </div>

        <b-modal
          no-close-on-esc
          no-close-on-backdrop
          size="m"
          ref="itemDelConfirm"
          title="Confirmation for deleting this item ?"
          hide-footer
          centered
        >
          <b-button
            variant="success"
            style="margin-left: 27%"
            @click="confirmItemDelete()"
          >
            Confirm
          </b-button>

          <b-button variant="danger" class="ml-2" @click="cancleItemDelete()">
            Cancel
          </b-button>
        </b-modal>

        <b-row>
          <b-col md="10">
            <b-button
              v-if="itemArrayShow.length > 0"
              variant="warning"
              @click="addRefuelStation"
              id="addButtonLoader"
            >
              {{ stockInDetails.poOrderId != "" ? "Update PO" : "Add New PO" }}
            </b-button>

            <b-button
              class="ml-2"
              variant="primary"
              @click="addStockFrom(stockInDetails.poOrderId)"
              v-if="stockInDetails.poOrderId != ''"
              id="addButtonLoader1"
            >
              Add Stock-In
            </b-button>
            <md-spinner md-indeterminate id="loader1" style="display: none"></md-spinner>
          </b-col>

          <b-col md="8">
            <div v-if="POPdf != ''">
              <span v-html="POPdf">
                {{ POPdf }}
              </span>
            </div>
          </b-col>
        </b-row>
        <br />
      </md-card-content>
    </md-card>

    <!-- Vendor Name Modal Added By Shreshth Gahlot Start -->
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      size="l"
      ref="VendorName-modal"
      hide-footer
      title="Add New Vendor"
    >
      <b-row>
        <b-col md="8">
          <label>Vendor Name <span class="error">*</span></label>
          <b-form-input
            :formatter="capitalizeAll"
            id="vendor_LglNm"
            name="vendor_LglNm"
            v-model="VendorMaster.vendor_LglNm"
          ></b-form-input>
          <span class="error" v-if="!VendorMaster.vendor_LglNm">{{
            VendorErrorList.vendor_LglNm
          }}</span>
        </b-col>

        <b-col md="2" class="text-center">
          <b-button
            style="margin-top: 37px"
            variant="outline-primary"
            @click="addVendorName"
            id="addButtonLoader"
            size="sm"
          >
            Add New Vendor
          </b-button>
        </b-col>
      </b-row>

      <b-row class="justify-content-center mt-4">
        <b-col md="2">
          <b-button variant="outline-danger" size="sm" @click="hideType">
            Cancle
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
    <!-- Vendor Name Modal Added By Shreshth Gahlot End -->

    <!-- Item Modal Added By Shreshth Gahlot Start -->
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      size="xl"
      ref="Item-modal"
      hide-footer
      title="Add New Item"
    >
      <b-row class="justify-content-center">
        <b-col md="3">
          <label>Item Name <span class="error">*</span></label>
          <b-form-input
            :formatter="capitalizeAll"
            id="itemNameValue"
            name="itemNameValue"
            v-model="itemMaster.itemNameValue"
          ></b-form-input>
          <span class="error" v-if="!itemMaster.itemNameValue">{{
            itemMasterErrorList.itemNameValue
          }}</span>
        </b-col>

        <!-- <b-col md="3">
          <label>Item Code <span class="error">*</span></label>
          <b-form-input :formatter="capitalizeAll"
            id="itemCodeValue"
            name="itemCodeValue"
            v-model="itemMaster.itemCodeValue"
          ></b-form-input>
          <span class="error" v-if="!itemMaster.itemCodeValue"> {{ itemMasterErrorList.itemCodeValue }} </span>
        </b-col> -->

        <b-col md="2">
          <label>Item Category <span class="error">*</span></label>
          <b-form-input
            :formatter="capitalizeAll"
            id="item_category"
            name="item_category"
            v-model="itemMaster.item_category"
          ></b-form-input>
          <span class="error" v-if="!itemMaster.item_category">{{
            itemMasterErrorList.item_category
          }}</span>
        </b-col>

        <b-col md="2">
          <label>Part Number <span class="error">*</span></label>
          <b-form-input
            :formatter="capitalizeAll"
            id="part_number"
            name="part_number"
            v-model="itemMaster.part_number"
          ></b-form-input>
          <span class="error" v-if="!itemMaster.part_number">
            {{ itemMasterErrorList.part_number }}
          </span>
        </b-col>

        <b-col md="2">
          <label>Unit of New Item <span class="error">*</span></label>
          <model-list-select
            :list="UnitList"
            v-model="itemMaster.unit"
            option-value="unitVal"
            option-text="unitText"
            placeholder="Select Unit"
          ></model-list-select>
          <span class="error" v-if="!itemMaster.unit">{{
            itemMasterErrorList.unit
          }}</span>
        </b-col>

        <b-col md="3" class="text-center pull-right">
          <b-button
            style="margin-top: 37px"
            variant="outline-primary"
            @click="addItemMaster"
            id="addButtonLoader"
            size="m"
          >
            Add Item
          </b-button>

          <b-button
            style="margin-top: 37px"
            variant="outline-danger"
            class="ml-2"
            size="m"
            @click="hideItemType"
          >
            Close
          </b-button>

          <md-spinner md-indeterminate id="loader" style="display: none"></md-spinner>
        </b-col>
      </b-row>
    </b-modal>
    <!-- Item Modal Added By Shreshth Gahlot End -->

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
      @close="onClose"
    ></md-dialog-alert>

    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop1"
      @close="onClose1"
    ></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../../helper/filters";
import { globalPermissionStatus } from "../../../helper/collection";
import CommonService from "../../../services/CommonService.js";
import ClientUserService from "../../../services/ClientUserService.js";
import CustomLoader from "../../common/customLoader.vue";

export default {
  beforeMount() {
     this.$store.dispatch(
        "common/setAllBranchList",
        JSON.stringify({
          filter: "BranchList",
          active: "all",
        })
      );
    if (globalPermissionStatus("Maintanence")) {
      this.$store.dispatch("setCurrentRoute", "/poOrder/poOrder");
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
    this.$store.dispatch(
      "commonDropdownMaster/setAllTallyVendorDDList",
      JSON.stringify({
        itemCode: "All_Vendor_List",
        Filter: { statusFilter: "1" },
        type: "Normal",
      })
    );
    let payload_curr = {
      Currency: "Currency_DropDown",
    };
    this.$store.dispatch("common/setAllCurrencyList", JSON.stringify(payload_curr));
  },
  data() {
    return {
      notApplicableArr: [
        {
          vendor_add_id: 0,
          Gstnumber: "Not Applicable",
        },
      ],
      deletePoItemId: "",
      grandTotalAmount: "",
      grandTotalInWords: "",
      updateItemFlag: false,
      addItemPanel: false,
      vendorStateCode: "",
      pridelGSTCode:"",
      enableIgst: true,
      VendorMaster: {
        vendor_add_id: "",
        vendor_add_LglNm: "",
        TypeofAdd: "Vendor Master Add",
        vendor_type: this.$route.path == "/poOrder/poOrder" ? "2" : "3",
      },
      VendorMasterError: ["Please Enter Vendor Name"],
      VendorErrorList: {
        vendor_LglNm: "",
      },
      itemMaster: {
        itemId: "",
        itemNameValue: "",
        // itemCodeValue: "",
        item_category: "",
        part_number: "",
        unit: "",
        maintenance_type: "",
        item_vendor_name: "",
        fetchVendorName: "",
        TypeofAdd: "Item Master Add",
      },

      itemMasterErrorList: {
        itemNameValue: "",
        // itemCodeValue: "",
        item_category: "",
        part_number: "",
        unit: "",
      },

      itemMasterError: [
        "Item Name Required",
        // "Item Code Required",
        "Item Category Required",
        "Part Number Required",
        "Unit Required",
      ],

      UnitList: [
        {
          unitVal: "pcs",
          unitText: "Pcs",
        },
        {
          unitVal: "small pcs",
          unitText: "Small Pcs",
        },
        {
          unitVal: "kg",
          unitText: "Kg",
        },
        {
          unitVal: "litre",
          unitText: "Litre",
        },
      ],

      CurrencyList: [],
      selectDateFormat,
      docURL: URL_BASE_DOC,
      isLoading: false,
      maintenanceTypeName: [
        {
          maintenanceTypeVal: "transport",
          maintenanceTypeText: "Transport",
        },
        {
          maintenanceTypeVal: "yard",
          maintenanceTypeText: "Yard",
        },
        {
          maintenanceTypeVal: "office",
          maintenanceTypeText: "Office",
        },
      ],

      itemMasterAll: {},

      permissionStatus:
        this.$sessionsStorage.get("PermissionStatus") != "" &&
        this.$sessionsStorage.get("PermissionStatus") &&
        this.$sessionsStorage.get("PermissionStatus") == "Read"
          ? true
          : false,
      alert: {
        content:
          this.$sessionsStorage.get("editPOId") != "" &&
          this.$sessionsStorage.get("editPOId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok",
      },
      itemModal: {
        po_ratePerUnit: "",
        poItemId: "",
        itemId: "",
        itemNameCode: "",
        poOrderId: "",
        itemCode: "",
        itemName: "",
        ratePerUnit: "",
        itemQuantity: "",
        totalAmount: "",
        dummyItemName: "",
        fk_currency_id: "2",
        igst: "",
        igst_amount: "",
        sgst: "",
        sgst_amount: "",
        cgst: "",
        cgst_amount: "",
        final_amount: "",
        remarks: "",
      },
      BranchOfficeList: [],
      selectedBranch: null,
      selectedOffice: null,
      stockInDetails: {
        poOrderId: "",
        poItemId: "",
        maintenanceType: "",
        itemId: "",
        location: this.$sessionsStorage.get("branch_baseLocation"),
        addedByPerson: "",
        fk_vendor_add_id: "",
        poDate: "",
        vendorName: "",
        specificPoDetail: "",
        poExpiryDate: "",
        isPODateSelected: false,
        fk_branch_id: "",
        fk_office_id: "",
        branchGSTN:"",
        branch_name: "",
      },

      validate: true,
      maintenanceTypeError: "",
      locationError: "",
      addedByPersonError: "",

      poDateError: "",
      vendorNamError: "",
      branchError: "",
      branchGstError: "",
      // vendorGSTError: "",

      employeeMaster: [
        {
          employeeName: "ajit",
        },
      ],
      locationMaster: [
        {
          pickupLocation: "mumbai",
        },
      ],
      vendorMaster: ["abc"],

      itemDetail: [
        {
          itemCode: "ajit",
        },
      ],

      POPdf: "",
      locationDetail: [{}],
      dapartmentDetail: [],
      vendorDetail: [],
      itemArrayShow: [],
      itemNameError: "",
      poRatePerUnitError: "",
      igstError: "",
      sgstError: "",
      cgstError: "",
      itemQuantityError: "",

      gstList: [
        {
          gstVal: "0",
          gstText: "0% gst",
        },
        {
          gstVal: "9",
          gstText: "9% gst",
        },
        {
          gstVal: "14",
          gstText: "14% gst",
        },
        {
          gstVal: "2.5",
          gstText: "2.5% gst",
        },
      ],

      igstList: [
        {
          igstVal: "0",
          igstText: "0% igst",
        },
        {
          igstVal: "5",
          igstText: "5% igst",
        },
        {
          igstVal: "9",
          igstText: "9% igst",
        },
        {
          igstVal: "14",
          igstText: "14% igst",
        },
        {
          igstVal: "18",
          igstText: "18% igst",
        },
        {
          igstVal: "28",
          igstText: "28% igst",
        },
      ],
    };
  },
  watch: {
    itemMasterAll: {
      handler: function (newVal, oldVal) {
        this.findItemCode(newVal);
      },
      deep: true,
    },
  },
  mounted() {},
  created() {
    this.getDefaultValue();
  },
  beforeDestroy() {},
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
  },
  computed: {
    minExpiryDate() {
      if (this.stockInDetails.poDate) {
        return this.stockInDetails.poDate;
      }
      return null;
    },

    itemMasterList() {
      return this.itemDetail.map((item) => {
        item.displayList = `${item.itemName} - ${item.part_number}`;
        return item;
      });
    },

    locationMasterList() {
      return this.locationMaster;
    },
    employeeMasterList() {
      return this.employeeMaster;
    },
    maintenanceTypeList() {
      return this.maintenanceTypeName;
    },
    vendorList() {
      return this.vendorMaster;
    },
  },

  methods: {
    onBranchSelected(branch) {
      this.branchError = "";
      this.branchGstError = "";
      this.stockInDetails.branchGSTN = "";
      this.stockInDetails.fk_office_id = "";
      this.stockInDetails.branch_name = this.$store.getters["common/getAllBranchList"].filter((x) => {
        return x.pickupId == this.stockInDetails.fk_branch_id;
      })[0].mainLocation;
      this.getBranchBasedOfficeList();
    },
    getBranchName() {
      let branch = this.$store.getters["common/getAllBranchList"].filter((x) => {
        return x.pickupId == this.stockInDetails.fk_branch_id;
      });
      if (branch.length > 0) {
        this.stockInDetails.branch_name = branch[0].mainLocation;
      }
    },
    getGSTNO() {
      this.branchGstError = "";
      
      let office = this.BranchOfficeList.filter((x) => {
        return x.office_id == this.stockInDetails.fk_office_id;
      });
      console.log('office=>', office);
      if (office.length > 0) {
        this.stockInDetails.branchGSTN = office[0].long_gst_no;
        this.pridelGSTCode=office[0].gstCode;
      }
    },

    getBranchBasedOfficeList(){
      CommonService.getAllClientList({
        itemCode: "BranchOfficeList",
        active: "all",
        fk_branch_id: this.stockInDetails.fk_branch_id,
      })
        .then(async (response) => {
          if (
            response.status == 200 &&
            response.data &&
            response.data.BranchOfficeList
          ) {
            this.BranchOfficeList = response.data.BranchOfficeList.map((office) => {
              office.long_gst_no = office.gstCode + "" + office.GSTN;
              return office;
            });
          } else {
            // console.log(response.data);
          }
          // console.log("getAllBranchOfficeList", response);
        })
        .catch((err) => {
          console.log("Error in getting getAllBranchOfficeList ", err);
        });
    },
     
    getItemDetails(itemMasterAll) {
      console.log("itemMasterAll=>", itemMasterAll);
      this.itemModal.unit = itemMasterAll.unit;
    },
    showAddItemPanel() {
      this.addItemPanel = true;
    },
    enablePoExpiryDate() {
      this.stockInDetails.poExpiryDate = "";
    },

    doLoading() {
      this.isLoading = true;
    },
    doLoadingClose() {
      this.isLoading = true;

      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    checkVendorPridelGSTCode(){
      if(this.vendorStateCode ==this.pridelGSTCode){
        this.enableIgst = false;
      }else{
        this.enableIgst = true;
      }
    },

    GstDataGet(vendor_id, vendor_add_id) {
      console.log("salil vendor id", vendor_id);
      console.log("salil vendor gst id", vendor_add_id);
      this.isLoading = true;

      this.addItemPanel = false;
      let payload = {
        itemCode: "All_Vendor_GST_List",
        Filter: {
          statusFilter: "1",
          vendor_id: vendor_id,
          vendor_add_id: vendor_add_id,
        },
        type: "Normal",
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_TallyBilling/getTallyExpense.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.isLoading = false;

            console.log("State Code", data.MasterVendorList[0].vendor_add_Stcd);
            this.itemMaster.fetchVendorName = data.MasterVendorList[0].vendor_add_LglNm;
            this.vendorStateCode = data.MasterVendorList[0].vendor_add_Stcd;
          }
        })
        .catch((error) => {});

      this.$store.dispatch(
        "commonDropdownMaster/setAllTallyVendorGstDDList",
        JSON.stringify(payload)
      );
    },

    getDefaultValue() {
      if (
        this.$store.getters["commonDropdownMaster/getAllTallyVendorGstList"].length > 0
      ) {
        this.stockInDetails.fk_vendor_add_id = this.$store.getters[
          "commonDropdownMaster/getAllTallyVendorGstList"
        ][0].vendor_add_id;
      }
    },

    viewModalPage(itemID) {
      let array = this.itemArrayShow.filter((x) => {
        return x.poItemId == itemID;
      });
      // console.log(itemID);

      Object.keys(this.itemModal).map((x) => {
        this.itemModal[x] = array[0][x] || "";
      });

      this.updateItemFlag = true;
      // this.itemModal.dummyItemName = array[0].itemName + "-" + array[0].itemCode;
      console.log("item", array[0]);

      this.itemModal.dummyItemName = array[0].itemName + " - " + array[0].part_number;
      this.itemModal.unit=array[0].unit;
    },

    deleteItemConfirmation(item) {
      this.$refs["itemDelConfirm"].show();
      this.deletePoItemId = item;
    },

    confirmItemDelete() {
      this.deleteItem(this.deletePoItemId);
      this.$refs["itemDelConfirm"].hide();
      this.getData();
    },

    cancleItemDelete() {
      this.$refs["itemDelConfirm"].hide();
      this.deletePoItemId = "";
    },

    deleteItem(item, index) {
      console.log("deleted item id", item.poItemId);

      this.itemObj = item;
      this.indexNew = index;

      let paylod = {
        tableName: "main_poitem",
        tableId: "poItemId",
        tableIsActive: "is_item_active",
        value1: 0,
        tableVal: item.poItemId,
        isMailSend: "No",
        manual: "No",
      };

      ClientUserService.getAllActive(JSON.stringify(paylod))
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
          }
        })
        .catch((error) => {
          console.log("Catch on PO Item Active Error: ", error);
        });

      // console.log(paylod);
    },

    emptyRate() {
      this.itemModal.totalAmount = "";
      this.itemModal.po_ratePerUnit = "";
    },

    calTotalRate(po_ratePerUnit) {
      this.calFinalAmount();
      let amount = parseFloat(this.itemModal.itemQuantity) * parseFloat(po_ratePerUnit);
      this.itemModal.totalAmount = amount.toFixed(2);
    },

    calTotalRateAndRoundRate(po_ratePerUnit) {
      this.calTotalRate(po_ratePerUnit);
      this.itemModal.po_ratePerUnit = parseFloat(po_ratePerUnit).toFixed(2);
    },

    calFinalAmount() {
      this.itemModal.sgst = this.itemModal.cgst;
      const totalAmount = parseFloat(this.itemModal.totalAmount);

      if (this.vendorStateCode != this.pridelGSTCode) {
        const igstValue = parseFloat(this.itemModal.igst);

        const igstAmount = (igstValue / 100) * totalAmount;
        this.itemModal.igst_amount = igstAmount.toFixed(2);

        this.itemModal.final_amount = (totalAmount + igstAmount).toFixed(2);
      } else {
        const cgstValue = parseFloat(this.itemModal.cgst);
        const sgstValue = parseFloat(this.itemModal.sgst);

        const cgstAmount = (cgstValue / 100) * totalAmount;
        this.itemModal.cgst_amount = cgstAmount.toFixed(2);

        const sgstAmount = (sgstValue / 100) * totalAmount;
        this.itemModal.sgst_amount = sgstAmount.toFixed(2);

        this.itemModal.final_amount = (totalAmount + cgstAmount + sgstAmount).toFixed(2);
      }

      // console.log("salil cal:", this.itemModal.final_amount);
    },

    JqueryFun() {
      return $(function () {
        return $("#poTable").DataTable();
      });
    },
    validateModal() {
      let validate_new = true;

      if (this.vendorStateCode != this.pridelGSTCode) {
        if (this.itemModal.igst == "") {
          $("#igst").focus();
          this.igstError = "IGST Required";
          validate_new = false;
        }
      } else {
        if (this.itemModal.cgst == "") {
          $("#cgst").focus();
          this.cgstError = "CGST Required";
          validate_new = false;
        }
      }

      if (this.itemModal.po_ratePerUnit == "") {
        $("#po_ratePerUnit").focus();
        this.poRatePerUnitError = "Enter Rate";
        validate_new = false;
      }

      if (this.itemModal.itemQuantity == "") {
        $("#itemQuantity").focus();
        this.itemQuantityError = "Enter Quantity";
        validate_new = false;
      }

      if (!this.itemMasterAll.itemId && this.itemModal.poItemId == "") {
        $("#itemMasterAll").focus();
        this.itemNameError = "Select item name";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    addStockFrom(Id) {
      this.$sessionsStorage.set("editPOId", Id);

      this.$router.push({
        path: "/stockIn",
      });
    },

    findItemCode(item) {
      this.itemModal.itemName = item.itemName;
      this.itemModal.itemCode = item.itemCode;
      this.itemModal.ratePerUnit = item.ratePerUnit;
      this.itemModal.itemId = item.itemId;
    },
    getData() {
      this.doLoading();
      let vehicle_drive = {
        itemCode: "itemCode",
        serviceEstimationId: "",
      };
      console.log("Shreshth Gahlot vehicle_drive => ", vehicle_drive);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Maintenance/fetchToStockIn.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (
              this.$sessionsStorage.get("vendorName") != undefined &&
              this.$sessionsStorage.get("vendorName") != ""
            ) {
              this.stockInDetails.vendorName = this.$sessionsStorage.get("vendorName");
              this.GstDataGet(this.$sessionsStorage.get("vendorName"), "");
            }
            if (data.itemDetail.length > 0) {
              this.itemDetail = data.itemDetail;
            } else {
              this.itemDetail = [];
            }
            if (data.employeeMaster.length > 0) {
              this.employeeMaster = data.employeeMaster;
            }

            if (data.locationMaster.length > 0) {
              this.locationMaster = data.locationMaster;
            }
            if (data.vendorMaster.length > 0) {
              this.vendorMaster = data.vendorMaster;
            }

            if (
              this.$sessionsStorage.get("editPOId") != undefined &&
              this.$sessionsStorage.get("editPOId") != ""
            ) {
              this.viewStockDetail();
            } else {
              console.log("dsds");
              this.stockInDetails.addedByPerson = data.UserDetail[0].employeeName;
            }
            
            this.doLoadingClose();
          }
        })
        .catch((error) => {});
    },

    addItem() {
      this.validateModal();
      this.isLoading = true;

      if (this.stockInDetails.poOrderId != "") {
        this.itemModal["poOrderId"] = this.stockInDetails.poOrderId;
      } else {
        this.itemModal["poOrderId"] = "";
      }

      let payload = {
        itemModal: this.itemModal,
        view: "Po_Order",
      };

      console.log("PO Item Add Payload => ", payload);
      if (this.validate != false) {
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Maintenance/poItems.php`,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            console.log("Shreshth Gahlot PO Item Data => ", data);
            if (status == 200 && data) {
              this.stockInDetails.poItemId += "" + data.Id + ",";

              Object.keys(this.itemModal).map((x) => {
                this.itemModal[x] = "";
              });

              this.itemNameError = "";
              this.poRatePerUnitError = "";
              this.itemQuantityError = "";
              this.cgstError = "";
              this.igstError = "";

              this.onClose1();
              // this.getData();
              this.isLoading = false;
            }
          })
          .catch((error) => {});
      }
    },

    onClose(type) {
      this.$router.push({
        path: "/poOrder/poOrder",
      });
    },

    onClose1() {
      this.itemArrayShow = [];
      let payload = {
        poItemId: this.stockInDetails.poItemId,
      };
      if (this.stockInDetails.poOrderId != "") {
        payload["poOrderId"] = this.stockInDetails.poOrderId;
      } else {
        payload["poOrderId"] = "";
      }

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Maintenance/viewPoItems.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.itemArray.length > 0) {
              this.itemArrayShow = data.itemArray;
              this.grandTotalAmount = data.totalAmount;
              this.grandTotalInWords = data.totalAmountInWords;
            }

            this.updateItemFlag = false;
            // this.JqueryFun();
            this.getData();
          }
        })
        .catch((error) => {});
    },

    itemMasterFilter(list, query) {
      return this.itemDetail.filter((x) => {
        return x.part_number.toLowerCase().includes(query.toLowerCase());
      });
    },

    locationMasterFilter(list, query) {
      return this.locationMaster.filter((x) => {
        return x.pickupLocation.toLowerCase().includes(query.toLowerCase());
      });
    },

    employeeMasterFilter(list, query) {
      return this.employeeMaster.filter((x) => {
        return x.employeeName.toLowerCase().includes(query.toLowerCase());
      });
    },

    previousPoView() {
      this.$router.push({
        path: "/poOrder/viewPoOrder",
      });
    },
    openItemDialog() {
      this.$refs["dialog"].open();
    },
    viewStockDetail() {
      let payload = {
        editJob: "editJob",
        poOrderId: this.$sessionsStorage.get("editPOId"),
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Maintenance/viewPoDetails.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (data.clientId != "" && status == 200 && data) {
            if (data.stockInId != "") {
              this.$sessionsStorage.set("editStockInId", data.stockInId);
            }
            this.GstDataGet(
              data.editJob[0]["vendorName"],
              data.editJob[0]["fk_vendor_add_id"]
            );
            Object.keys(data.editJob[0]).map((x) => {
              this.stockInDetails[x] = data.editJob[0][x] || "";
            });

            console.log("data.editJob[0]", data.editJob[0],this.stockInDetails);

            if (
                this.stockInDetails.fk_branch_id &&
                this.$store.getters["common/getAllBranchList"].length > 0
              ) {
                this.getBranchBasedOfficeList();
                this.getGSTNO();
                this.getBranchName();
                this.GstDataGet(this.stockInDetails.vendorName, this.stockInDetails.fk_vendor_add_id);
              }
              console.log("this.stockInDetails.fk_branch_id", this.stockInDetails);

            this.stockInDetails.poItemId += ",";
            if(data.editJob.length > 0){
              this.stockInDetails.poItemId += data.editJob[0].poItemId;
            }
            if(data.editJob.length > 0){
              this.stockInDetails.fk_office_id = data.editJob[0].fk_office_id;
              this.stockInDetails.fk_vendor_add_id = data.editJob[0].fk_vendor_add_id;
            }

            this.poItemView(this.stockInDetails.poItemId);
          }
        })
        .catch((error) => {});
    },
    poItemView(poItemId) {
      let payload = {
        poItemId: poItemId,
      };

      payload["poOrderId"] = "";

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Maintenance/viewPoItems.php`,
        data: JSON.stringify(payload),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.itemArray.length > 0) {
              this.itemArrayShow = data.itemArray;
              this.grandTotalAmount = data.totalAmount;
              this.grandTotalInWords = data.totalAmountInWords;
            }

            this.$refs["addPop1"].close();
          }
        })
        .catch((error) => {});
    },

    validateJobOrder() {
      let validate_new = true;

      if (this.stockInDetails.fk_branch_id == "") {
        $("#fk_branch_id").focus();
        this.branchError = "Select Branch";
        validate_new = false;
      }

      if (this.stockInDetails.branchGSTN == "") {
        $("#fk_office_id").focus();
        this.branchGstError = "Select Branch GST";
        validate_new = false;
      }

      if (this.stockInDetails.location == "") {
        $("#location").focus();
        this.locationError = "Enter Location";
        validate_new = false;
      }

      if (this.stockInDetails.vendorName == "") {
        $("#vendorName").focus();
        this.vendorNamError = "Select Vendor";
        validate_new = false;
      }

      // if (this.stockInDetails.fk_vendor_add_id == "") {
      //   $("#vendor_add_id").focus();
      //   this.vendorGSTError = "Select Vendor GST";
      //   validate_new = false;
      // }

      if (this.stockInDetails.maintenanceType == "") {
        $("#maintenanceType").focus();
        this.maintenanceTypeError = "Select Maintenance Type";
        validate_new = false;
      }

      if (this.stockInDetails.poDate == "") {
        $("#Date").focus();
        this.poDateError = "Enter PO Date";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },

    addRefuelStation() {
      this.validateJobOrder();
      if (this.validate != false) {
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");
        console.log(this.stockInDetails);
        this.stockInDetails.pridelGSTCode = this.pridelGSTCode;
        this.stockInDetails.vendorGSTCode = this.vendorStateCode;
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Maintenance/addPoOrder.php`,
          data: JSON.stringify(this.stockInDetails),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };

        axios(options)
          .then((result) => {
            console.log("Shreshth Gahlot Result => ", result);
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.stockInDetails.poOrderId = data.Id;
              if (data.PdfData != "") {
                this.POPdf = data.PdfData;
              }
              $("#addButtonLoader").css("display", "block");
              $("#loader").css("display", "none");
              this.$refs["addPop"].open();

              this.$router.push({
                path: "/poOrder/viewPoOrder",
              });
            }
          })

          .catch((error) => {});
      }
    },

    // Added By Shreshth Gahlot Start
    openVendorNameModal() {
      this.isLoading = false;
      this.$refs["VendorName-modal"].show();
    },
    hideType() {
      this.$refs["VendorName-modal"].hide();
      this.isLoading = false;
      this.VendorMaster.vendor_LglNm = "";
    },
    validateVendorMaster() {
      let validate_new = true;
      Object.keys(this.VendorErrorList).map((x, index) => {
        if (
          this.VendorMaster[x] == "" ||
          this.VendorMaster[x] == undefined ||
          this.VendorMaster[x] == null
        ) {
          this.VendorErrorList[x] = this.VendorMasterError[index];
          validate_new = false;
        }
      });
      if (validate_new != true) {
        this.validate = false;
        return;
      } else {
        this.validate = true;
      }
    },
    addVendorName() {
      this.validateVendorMaster();
      this.VendorMaster.TypeofAdd = "Vendor Master Add";
      this.VendorMaster.vendor_type = this.$route.path == "/poOrder/poOrder" ? "2" : "3";

      if (this.validate == false) return false;
      this.isLoading = true;
      // console.log("loading:", this.isLoading);

      $("#loader").css("display", "block");
      let payload = {
        itemCode: "add_Vendor_Details",
        VendorMaster: this.VendorMaster,
        ModalAdd: "PO Order",
      };
      if (payload.itemCode == "add_Vendor_Details") {
        payload = JSON.stringify(payload);
        if (this.validate != false) {
          CommonService.getAllExpenseList(payload)
            .then((response) => {
              console.log("Shreshth Gahlot getAllExpenseList => ", response);
              const { data, status, statusText } = response;
              if (data.vendor_add_id) {
                this.getVendorType();
              }
              if (data.find == 2) {
                this.alert.content = data.MSG;
              } else {
                this.alert.content = data.MSG;
              }
              this.hideType();
              this.$refs["addPop"].open();
            })
            .catch((error) => {
              console.log("Catch on Vendor Name Error: ", error);
            });
        }
      }
    },
    getVendorType() {
      let payload = {
        itemCode: "VendorList",
      };
      payload = JSON.stringify(payload);
      CommonService.getAllExpenseList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          this.All_Document_TypeList = data.DocumentTypeList;
          console.log("this.All_Document_TypeList=>", data);
        })
        .catch((error) => {
          console.log("Catch on Document Type Error: ", error);
        });
    },
    openItemModal() {
      this.isLoading = false;
      // console.log("salil",this.itemMaster.fetchVendorName);
      this.itemMaster.maintenance_type = this.stockInDetails.maintenanceType;
      this.itemMaster.item_vendor_name = this.itemMaster.fetchVendorName;
      this.$refs["Item-modal"].show();
    },
    hideItemType() {
      this.itemMaster.itemNameValue = "";
      // this.itemMaster.itemCodeValue = "";
      this.itemMaster.item_category = "";
      this.itemMaster.part_number = "";
      this.itemMaster.unit = "";

      this.$refs["Item-modal"].hide();
      this.isLoading = false;
    },
    validateItemMaster() {
      let validate_new = true;
      Object.keys(this.itemMasterErrorList).map((x, index) => {
        if (
          this.itemMaster[x] == "" ||
          this.itemMaster[x] == undefined ||
          this.itemMaster[x] == null
        ) {
          this.itemMasterErrorList[x] = this.itemMasterError[index];
          validate_new = false;
        }
      });
      if (validate_new != true) {
        this.validate = false;
        return;
      } else {
        this.validate = true;
      }
    },
    addItemMaster() {
      this.validateItemMaster();
      if (this.validate != false) {
        let payload = {
          itemMaster: this.itemMaster,
          ModalAdd: "PO Order",
        };
        payload = JSON.stringify(payload);
        console.log("Shreshth Gahlot => ", payload);
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Maintenance/addItem.php`,
          data: payload,
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              this.getData();
              this.hideItemType();
              this.alert.content = data.msg;
              this.$refs["addPop"].open();

              // console.log( "salil:", data.itemId);
            }
          })
          .catch((error) => {});
      }
    },
  },
};
</script>

<style>
.md-direction-bottom-right {
  width: 16% !important;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.md-card .md-card-content:last-child {
  height: 100vh;
}

.activeClass {
  display: none;
}

.error {
  color: red;
}

.success {
  color: green;
}

.grandTotalSection {
  font-size: 15px;
  text-align: end;
  background-color: darkgrey;
}

.md-dialog-container.HereDialog.md-theme-default {
  z-index: 1;
}

.md-dialog-container.HereDialog.md-theme-default .md-dialog {
  width: 50%;
  height: 50%;
}

.md-select-content {
  z-index: 999999999;
}

.marg-top {
  margin-top: 0%;
}

.delete-button {
  background-color: red;
}

@media (min-width: 320px) and (max-width: 767px) {
  .mobile-width {
    min-width: 100%;
    display: inline-block;
  }
}
</style>



// WEBPACK FOOTER //
// poOrder.vue?226b6377